import TableData from '../../../components/ui/TableData'
import { useGetAccountsListPerBorrowBook } from '../../../service/BookBorrowServiceNew' // chú ý export đúng
import { useNav } from '../../../hooks/useNav'
import { useState } from 'react'
import { Icon } from '@iconify/react/dist/iconify.js'
import PopUpConfirmReacllBookBorrow from './PopUpConfirmRecall'
import { updateUserBorrowReturnStatus } from '../../../service/updateUserBorrowReturnStatus'
export default function AccountListPerBorrowBook({ path, uuidBook }) {
  const [isCheckBox, setIsCheckBox] = useState(false)
  const [idUserPresent, setIdUserPresent] = useState(null)
  // Lấy data từ hook React Query
  const {
    data: {
      totalResult = 0,
      totalPages = 1,
      currentPage = 0,
      accounts = [],
    } = {},
  } = useGetAccountsListPerBorrowBook(uuidBook)
  const columnMapping = [
    { key: 'Accounts', value: 'Mã Sinh Viên' },
    { key: 'fullName', value: 'Họ và tên' },
    { key: 'borrowDate', value: 'Ngày mượn' },
    { key: 'returnDate', value: 'Ngày trả' },
  ]

  const columnWidths = {
    idAccounts: 'w-[10.83vw]',
    fullName: 'w-[10.83vw]',
    borrowDate: 'w-[10.83vw]',
    returnDate: 'w-[10.83vw]',
  }

  const actionButtons = [
    {
      title: 'Thu hồi sách khỏi sinh viên',
      icon: (
        <Icon
          icon={'material-symbols:settings-backup-restore'}
          className="text-3xl text-main-grey"
        />
      ),
      onClick: (row) => {
        setIsCheckBox(true)
        setIdUserPresent(row)
      },
      label: 'Thu hồi sách',
    },
  ]
  const onConfirm = async () => {
    setIsCheckBox(false)
    await updateUserBorrowReturnStatus.UpdateStatus(
      uuidBook,
      idUserPresent.idAccount
    )
    window.location.reload()
  }
  const onClose = () => {
    setIsCheckBox(false)
  }

  return (
    <>
      <TableData
        data={accounts}
        columnMapping={columnMapping}
        columnWidths={columnWidths}
        actionButtons={actionButtons}
        path={path}
        dataType="tài khoản"
        currentPage={currentPage + 1} // backend trả 0-based
        pageSize={10}
        totalItems={totalResult}
        totalPages={totalPages}
      />
      {isCheckBox ? (
        <PopUpConfirmReacllBookBorrow onClose={onClose} onConfirm={onConfirm} />
      ) : null}
    </>
  )
}
